var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dmfyh7kria",
    d: "M0 0h27.783v30.229H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yyqaf84vjc",
    d: "M0 0h7.88v8.06H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.106 13.384)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3mf4wb5pwb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dmfyh7kria"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.62 25.427v-6.453H10.08l5.084-8.8v6.454h2.542l-5.085 8.799zM14.715.323a1.212 1.212 0 0 0-1.647 0L.39 11.125a1.214 1.214 0 0 0 .824 2.106h1.751V30.23h21.853V13.231h1.751a1.216 1.216 0 0 0 .824-2.106L14.715.323z",
    fill: "#FFF",
    mask: "url(#3mf4wb5pwb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.192 9.505c.443.552 1.168.552 1.611 0l2.855-3.562c.442-.552.225-1.005-.483-1.005H17.38V1.382l-.004-.098a1.38 1.38 0 0 0-2.76.098v3.556H12.82c-.709 0-.925.453-.482 1.005l2.854 3.562z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.195)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mj841io41d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#yyqaf84vjc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.734 8.052c.704.078 1.216-.435 1.139-1.138l-.5-4.537c-.078-.704-.55-.87-1.052-.37l-1.18 1.18L2.36.405 2.28.33A1.382 1.382 0 0 0 .405 2.36l2.783 2.782-1.361 1.36c-.5.5-.334.973.37 1.052l4.537.5z",
    fill: "#FFF",
    mask: "url(#mj841io41d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.595 6.6a1.382 1.382 0 0 0-1.954 0l-2.785 2.785-1.182-1.182c-.501-.501-.974-.335-1.052.37l-.5 4.536c-.077.703.435 1.216 1.14 1.139l4.536-.5c.704-.077.87-.551.37-1.052L28.81 11.34l2.785-2.785.073-.078a1.382 1.382 0 0 0-.073-1.876",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.875a4e4143839386612b755515463886.svg";
export { ForwardRef as ReactComponent };